export default __webpack_public_path__ + "e91b3f3db63bca37507a6990a23fd542.png";